export default __webpack_public_path__ + "static/totalwebconnections-4dc25ba7d37633eb21ab1c0d1aa851a8.png";